import { render } from "./HollowSpinner.vue?vue&type=template&id=edb20838&scoped=true"
import script from "./HollowSpinner.vue?vue&type=script&lang=js"
export * from "./HollowSpinner.vue?vue&type=script&lang=js"

import "./HollowSpinner.vue?vue&type=style&index=0&id=edb20838&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb20838"]])

export default __exports__